export default "__VITE_ASSET__DUgWsKWo__"